import http from '@/app/services/httpServices';
import URL_UTILITY from '../../.././app/utility/url.utility';

const panAadhaarVerify = (context, payload) => {
  return http.postApi(
    URL_UTILITY.postPanBankExcelDataUrl + '/pan-comprehensive',
    payload
  );
};

const getEventId = (context, payload) => {
  return http.getApi(
    URL_UTILITY.getWorkflowEventUrl + '/get-event-id/' + payload.event_name
  );
};

export default {
  panAadhaarVerify,
  getEventId
};
